/**
 * 项目用户信息设置
 * */

import localStorageProxy from "./listenToStorage"

const user = 'platform_user'

// 获取
export function getUser() {
  return window.localStorage.getItem(user)
}

// 设置
export function setUser(e) {
  // return window.localStorage.setItem(user, e)
  return localStorageProxy[user] = e
}




// WEBPACK FOOTER //
// ./src/utils/user.js